import { environnement } from "configs/environnement";
import api from "./api";
import {
  IExpenseResponse,
  ISaveExpense,
  IUpdateExpense,
} from "models/church.types";

const BASE_URL = `${environnement.baseURL}/expenses`;

export const ExpenseService = {
  /**
   * GET /api/expenses/v1/expenses/_search
   * Récupère la liste des dépenses (pagination standard)
   */
  getAll: async (page: number, size: number) => {
    const response = await api.get<IExpenseResponse[]>(`${BASE_URL}/_search`, {
      params: {
        page: page,
        size: size,
        sort: "id,desc",
        query: "",
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * POST /api/expenses/v1/expenses
   */
  create: async (expense: ISaveExpense): Promise<IExpenseResponse> => {
    const response = await api.post<IExpenseResponse>(`${BASE_URL}`, expense);
    return response.data;
  },

  /**
   * PUT /api/expenses/v1/expenses
   */
  update: async (expense: IUpdateExpense): Promise<IExpenseResponse> => {
    const response = await api.put<IExpenseResponse>(`${BASE_URL}`, expense);
    return response.data;
  },

  /**
   * GET /api/expenses/v1/expenses/{id}
   */
  getById: async (id: number): Promise<IExpenseResponse> => {
    const response = await api.get<IExpenseResponse>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * DELETE /api/expenses/v1/expenses/{id}
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * GET /api/expenses/v1/expenses/_search
   * Recherche par query
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IExpenseResponse[]>(`${BASE_URL}/_search`, {
      params: {
        query: query,
        page: page,
        size: size,
        sort: "id,desc",
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * GET /api/expenses/v1/expenses/summary
   * Récupère le total des dépenses selon les filtres
   */
  getSummary: async (
    startDate?: string,
    endDate?: string,
    category?: string,
  ): Promise<number> => {
    const response = await api.get<number>(`${BASE_URL}/summary`, {
      params: {
        startDate,
        endDate,
        category,
      },
    });
    return response.data;
  },
};
